import { request } from '@/api/httpClient'

export async function vendorUpdateThisGridAnomaly(datasetId, id, gridId, overrideCells, customerId) {
  return request({
    method: 'vendor/UpdateThisGridAnomaly',
    payload: {
      Id: id,
      CustomerId: customerId,
      OverrideCells: overrideCells,
      DatasetId: datasetId,
      FinancialGridConfigurationId: gridId
    }
  })
}

export async function vendorGetThisGridAnomaly(id, customerId, datasetId) {
  return request({
    method: 'vendor/GetThisGridAnomaly',
    payload: {
      Id: id,
      CustomerId: customerId,
      DatasetId: datasetId
    }
  })
}

export async function vendorGetAnomalies(datasetId) {
  return request({
    method: 'vendor/GetAnomalies',
    payload: {
      DatasetId: datasetId,
      Limit: 500,
      Offset: 0
    }
  })
}
